import {AppTheoryIcon} from "shared/UI/UIKit/icons/Theory";
import {AppLiteratureIcon} from "shared/UI/UIKit/icons/Literature";
import {Num01Icon} from "shared/UI/UIKit/icons/Num01";
import {Num02Icon} from "shared/UI/UIKit/icons/Num02";
import {Num03Icon} from "shared/UI/UIKit/icons/Num03";
import {Num04Icon} from "shared/UI/UIKit/icons/Num04";
import {Num05Icon} from "shared/UI/UIKit/icons/Num05";
import {Num06Icon} from "shared/UI/UIKit/icons/Num06";
import {Num07Icon} from "shared/UI/UIKit/icons/Num07";
import {Num08Icon} from "shared/UI/UIKit/icons/Num08";
import {Num09Icon} from "shared/UI/UIKit/icons/Num09";
import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "",
        subject: "Методические рекомендации по преподаванию родной (русской) литературы, 5-9 классы",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Методические рекомендации по преподаванию родной (русской) литературы, 5-9 классы",
        authorsTitle: "Автор",
        authors: [
            {
                author: "",
                grade: "",
                subGrade: "",
                imageSrc: ""
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            icon: AppTheoryIcon,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1",
            title: "Методические рекомендации по преподаванию родной (русской) литературы, 5-9 классы",
            htmlPath: "./interactive/metrek/index.html",
            autoHeight: false
        },
        {
            order: 2,
            icon: Num01Icon,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "2",
            title: `Игра «Поговорка – цветочек, пословица – ягодка»`,
            htmlPath: "./interactive/poslov/index.html",
            autoHeight: false
        },
        {
            order: 3,
            icon: Num02Icon,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "3",
            title: `Игра «Угадай сказку о медведе»`,
            htmlPath: "./interactive/medved/index.html",
            autoHeight: false
        },
        {
            order: 4,
            icon: Num03Icon,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "4",
            title: `Игра «Прогулка по Петербургу»`,
            htmlPath: "./interactive/spb/index.html",
            autoHeight: false
        },
        {
            order: 5,
            icon: Num04Icon,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "5",
            title: `Игра «Масленичная неделя»`,
            htmlPath: "./interactive/maslen/index.html",
            autoHeight: false
        },
        {
            order: 6,
            icon: Num05Icon,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "6",
            title: `Игра «Печём блины»`,
            htmlPath: "./interactive/blin/index.html",
            autoHeight: false
        },
        {
            order: 7,
            icon: Num06Icon,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "7",
            title: `Игра «Найти пару»`,
            htmlPath: "./interactive/para/index.html",
            autoHeight: false
        },
        {
            order: 8,
            icon: Num07Icon,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "8",
            title: `Игра «Русская изба»`,
            htmlPath: "./interactive/izba/index.html",
            autoHeight: false
        },
        {
            order: 9,
            icon: Num08Icon,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "9",
            title: `Игра «Узнай героя войны: кто есть кто?»`,
            htmlPath: "./interactive/warheroes/index.html",
            autoHeight: false
        },
        {
            order: 10,
            icon: Num09Icon,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "10",
            title: `Игра «Угадай автора стихотворения»`,
            htmlPath: "./interactive/poetry/index.html",
            autoHeight: false
        },
        {
            order: 11,
            icon: AppLiteratureIcon,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Аверьянова А.П. Как образуются слова. М.; Л., 1966.",
                "Акишина А.А. Речевой этикет русского телефонного разговора.  М., 2000.",
                "Акишина А.А., Формановская Н.И. Русский речевой этикет. М., 1978.",
                "Вартаньян Э.А. Путешествие в слово. М., 1986.",
                "Вартаньян Э.А. Рождение слова.  М., 1970.",
                "Быстрова ЕЛ. Диалог культур на уроках русского языка. СПб., 2002.",
                "Голанова Е.И. Как возникают названия.  М., 1989.",
                "Горбачевич К.С. Русский язык. Прошлое. Настоящее. Будущее. М., 1984.",
                "Граудина Л.К. Беседы о русской грамматике.  М., 1983.",
                "Голуб И.Б., Розенталь Д.Э. Секреты хорошей речи. М., 1993.",
                "Голуб И.Б., Розенталь Д.Э. Занимательная стилистика.  М., 1989.",
                "Горелов И., Еталычев В. Безмолвный мысли знак: Рассказы о невербальной коммуникации.  М., 1991.",
                "Горшков А.И. Все богатство, сила и гибкость нашего языка (А.С. Пушкин в истории русского языка). М., 1992.",
                "Граник Г.Г., Бондаренко С.М. Секреты пунктуации. М., 1986.",
                "Журавлев А.П. Звук и смысл. М., 1991.",
                "Кодухов В.И. Рассказы о синонимах. М., 1984.",
                "Колесов В.В. Культура речи — культура поведения. Л., 1988.",
                "Костомаров В.Г. Жизнь языка. М., 1994.",
                "Крысин Л.П. Язык в современном обществе.  М., 1977.",
                "Леонтьев А.А. Путешествие по карте языков мира. М., 1981.",
                "Львова С.И. «Позвольте пригласить Вас...», или Речевой этикет. М., 2004.",
                "Львова С. И. Русский язык. 5-9 классы. Игры на развитие речи. ФГОС. М.: Экзамен, 2019 г.",
                "Львова С. И. Русский язык. 5-9 классы. Лингвистические игры. ФГОС. М.: Экзамен, 2020 г.",
                "Львова С. И. Русский язык в кроссвордах. М.: Дрофа, 2007.",
                "Львова С.И. Словообразование — занимательно о серьезном: Практические задания для учащихся 8—11 классов. — М., 2006.",
                "Люстрова З.Л., Скворцов Л. Л., Дерягин ВЯ. Беседы о русском слове. М., 1987.",
                "Матвеев В. М., Панов АЛ. В мире вежливости. М., 1976.",
                "Матвеева Н.П. Свидетели истории народа.  М., 1992.",
                "Мокиенко В.М. Образы русской речи. — Л., 1986.",
                "Моисеев А.И. Звуки и буквы, буквы и цифры. — М.. 1986.",
                "Панов Л.В. Занимательная орфография. — М., 1984.",
                "Пташкина В. Н. Игровые технологии на уроках русского языка. 5-9 классы: игры со словами, разработки уроков [Пташкина В. Н., Виноградова К., Амбушева Т., Чурзина О.,. Баскакова В, Макарова О., Тареева Л., Попова Е., Шахназарян Л.] . Волгоград: Учитель, 2023.",
                "Откупщиков Ю.В. К истокам слова. Рассказы о науке этимологии. — М., 1986.",
                "Постникова И.И. и др. Это непростое простое предложение. - М., 1985.\n" +
                "Розенталь Д.Э. А как сказать лучше? — М., 1988.\n",
                "Скворцов Л.И. Культура русской речи: Словарь-справочник. — М., 2003.",
                "Скворцов Л.И. Правильно ли мы говорим по-русски? — М., 1983. ",
                "Скворцов Л.И. Экология слова, или Поговорим о культуре русской речи. — М., 1996",
                "Формановская Н.И. Вы сказали: «Здравствуйте!» (Речевой этикет в нашем общении). — М., 1982.",
                "Формановская Н.И. Речевой этикет и культура общения. — М., 1989.",
                "Шанский Н.М. Занимательный русский язык: в 2 ч. — М., 1996.",
                "Шанский Н.М. Художественный текст под лингвистическим микроскопом. — М., 1986.",
                "Энциклопедический словарь юного филолога (языкознание) / сост. М.В. Панов. — М., 1984."
            ],
            literaturesSec: [
                "Агапова И., Давыдова М. Литературные игры для детей.  М.: Лада, 2011. 192 с.",
                "Андреева М. С. Сивка-Бурка и другие... [Электронный ресурс]: литературная игра для детей младшего и среднего школьного возраста, посвященная лошадям / М. С. Андреева, М. П. Короткова: [б. и.] // Библиотека в школе.  2013.  № 11.  Прил.: 1 эл. опт. диск (CD-ROM).",
                "Аникеева Н.П. Воспитание игрой [Текст]: учеб. пособие / Н.П. Аникеева. Москва: «Прогресс», 2010 г. 90 с.",
                "Белова О. И. Игра как средство развития творческой активности школьников на уроках литературы: диссертация кандидата педагогических наук: 13.00.02.  Ленинград, 1984. 185 с.",
                "Богуславская Н.Е. Веселый этикет. Развитие коммуникативных способностей ребенка / Н. Е. Богуславская; Н. А. Купина. 3-е изд., испр. М.: Флинта: Наука, 2007.176 с.",
                "Бычкова О. А., Никитина А.В. Образы игры и игрока в пространстве литературы и компьютерных игр // Человек и культура. 2020. №6. URL: https://cyberleninka.ru/article/n/obrazy-igry-i-igroka-v-prostranstve-literatury-i-kompyuternyh-igr (дата обращения: 02.11.2023).",
                "Гельфонд М.М. «Я сделал вновь поэзию игрой…», или Веселые разминки на уроках литературы//Литература. 2013. Апрель. С.26-28.",
                "Демин М.В. Труд и игра как виды и аспекты человеческой деятельности [Текст] / М.В. Демин // Вестн. Моск. ун-та. Сер. 7, Философия.  1983.  № 1. С. 14-22.",
                "Емельянова, Т.В. Игровые технологии в образовании : электронное учеб.-метод. пособие / Т.В. Емельянова, Г.А. Медяник. – Тольятти : Изд-во ТГУ, 2015 – 1 оптический диск. ",
                "Казанцева, Е. А. Игровые технологии в образовании : учебное пособие / Е. А. Казанцева. – Курган : Изд-во Курганского гос. ун-та, 2021. – 112 с.",
                "Крупская Л.И. Литературные игры и инсценировки школьников [Текст]: кружок художественного чтения / Л. И. Крупская.  Москва: Издательство АПН РСФСР, 1960. 47 с.",
                "Кучина Т.Г., Болдырева Е.М. Литература. Интеллектуальные игры для школьников. Ярославль: Академия развития, Академия К. 1998. 240 с.",
                "Литвинов В.В. Литературные задачи и игры для учащихся старших классов. Литература в школе [Текст] / В. В. Литвинов / М.: 1964, I, с.49-56.",
                "Минкин Е.М. От игры к знаниям. М.: Просвещение, 1983. 254 с.",
                "Сиденко, А.С. Игровой подход в обучении / [Текст] / Народное образование, № 8. 2000 г. С. 134 – 137.",
                "Уминова Н. В. Игровые технологии на уроках литературы в старших классах // Вестник КГПУ им. В.П. Астафьева. 2016. №3 (37). URL: https://cyberleninka.ru/article/n/igrovye-tehnologii-na-urokah-literatury-v-starshih-klassah (дата обращения: 02.11.2023).",
                "Шайхетдинова Л. Р. Игровые технологии как фактор познавательной деятельности учащихся [Электронный ресурс]/Л.Р. Шайхетдинова //ИД «Первое сентября»/ фестиваль педагогических идей «Открытый урок». Режим доступа: httр://fеstivаl.1sерtеmbеr.ru/аrticlеs/522077.",
                "Эльконин, Д.Б. Психология игры. [Текст] / Д.Б. Эльконин /М.:   ВЛАДОС, 1999.  358 с."
            ],
            filesToDownload: [
                {
                    link: "./files/metrek.pdf",
                    fileName: "Методические рекомендации по преподаванию родной (русской) литературы, 5-9 классы"
                }
            ]
        }
    ],
};
